/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
import { MLGafUtil } from 'ml-portals-util-react';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import './MLPayrollDeductComponent.messages';
import metadata from './MLPayrollDeductComponent.metadata.json5';
import styles from './MLPayrollDeductComponent.module.scss';


// ML: MLPaymentDetailsMethodPayrollDeductDeirectiveCtrl.js, ml-payment-details-method-payroll-deduct.html

function MLPayrollDeductComponent(props) {
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    

    const {
        id,
        onValidate,
        showValidationErrors,
        gafInfoObject,
        hasSsn,
        hasDepartmentNumber,
        hasEmployeeNumber,
        hasMetroBadgeNumber,
        submissionVM,
        updateWizardData
    } = props;

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const [enableInvalidSSNValidation, setEnableInvalidSSNValidation] = useState(false);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    useEffect(()=> {
            MLPortalSettingsService.getSettings(authHeader).then((response) => {
                setEnableInvalidSSNValidation(!!response?.enableInvalidSSNValidation_Ext);
            });
    },[])

    const writeValue = useCallback(
        (value, path) => {
            _.set(gafInfoObject.gafInfo, path, value);
            
            _.set(submissionVM, "baseData.gafInfo_ML", gafInfoObject.gafInfo);
            
            updateWizardData(submissionVM);
            
            refreshData();
        },
        [gafInfoObject.gafInfo, refreshData]
    );

    const resolvers = {
        resolveClassNameMap: styles
    };

     const { validateSsnField } = MLGafUtil();

    const overrides = {
        // payroll deduct fields
        ssnRow: {
            visible: !hasSsn
        },
        ssn: {
            showValidationErrors,
            validationMessages: validateSsnField(gafInfoObject, enableInvalidSSNValidation)
        },
        departmentNumberRow: {
            visible: _.defaultTo(gafInfoObject.gafInfo.departmentNumberUsage.value, false) && _.isUndefined(_.get(gafInfoObject, `gafInfo.employeeDepartmentNumberLength`))
        },
        departmentNumberTextRow: {
            visible: _.defaultTo(gafInfoObject.gafInfo.eligibilityVerified.value, false) && hasDepartmentNumber
        },
        departmentNumberTextLiteral: {
            content: gafInfoObject.gafInfo.departmentNumberLiteral.value
        },
        departmentNumberTextValue: {
            content: gafInfoObject.gafInfo.departmentNumber.value
        },
        departmentNumber: {
            visible: !hasDepartmentNumber
        },
        employeeNumberRow: {
            visible: _.defaultTo(gafInfoObject.gafInfo.employeeNumberUsage.value, false) && _.isUndefined(_.get(gafInfoObject, `gafInfo.employeeDepartmentNumberLength`))
        },
        employeeNumberTextRow: {
            visible: _.defaultTo(gafInfoObject.gafInfo.eligibilityVerified.value, false) && hasEmployeeNumber
        },
        employeeNumberTextLiteral: {
            content: gafInfoObject.gafInfo.employeeNumberLiteral.value
        },
        employeeNumberTextValue: {
            content: gafInfoObject.gafInfo.employeeNumber.value
        },
        employeeNumber: {
            visible: !hasEmployeeNumber
        },
        metroBadgeNumberRow: {
            visible: _.defaultTo(gafInfoObject.gafInfo.metroBadgeNumberUsage.value, false)
        },
        metroBadgeNumberTextRow: {
            visible: _.defaultTo(gafInfoObject.gafInfo.eligibilityVerified.value, false) && hasMetroBadgeNumber
        },
        metroBadgeNumberTextLiteral: {
            content: gafInfoObject.gafInfo.metroBadgeNumberLiteral.value
        },
        metroBadgeNumberTextValue: {
            content: gafInfoObject.gafInfo.metroBadgeNumber.value
        },
        metroBadgeNumber: {
            visible: !hasMetroBadgeNumber
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={gafInfoObject.gafInfo}
            onValidationChange={setComponentValidation}
            showErrors={showValidationErrors}
            onValueChange={writeValue}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

MLPayrollDeductComponent.propTypes = {
    id: PropTypes.string.isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    //
    gafInfoObject: PropTypes.shape({
        gafInfo: PropTypes.shape({
            payrollDeductAvailable: PropTypes.shape({
                value: PropTypes.bool
            }),
            ssn: PropTypes.shape({
                value: PropTypes.string
            }),
            departmentNumber: PropTypes.shape({
                value: PropTypes.string
            }),
            departmentNumberLiteral: PropTypes.shape({
                value: PropTypes.string
            }),
            employeeNumber: PropTypes.shape({
                value: PropTypes.string
            }),
            employeeNumberLiteral: PropTypes.shape({
                value: PropTypes.string
            }),
            metroBadgeNumber: PropTypes.shape({
                value: PropTypes.string
            }),
            metroBadgeNumberLiteral: PropTypes.shape({
                value: PropTypes.string
            }),
            eligibilityVerified: PropTypes.shape({
                value: PropTypes.bool
            }),
            departmentNumberUsage: PropTypes.shape({
                value: PropTypes.bool
            }),
            employeeNumberUsage: PropTypes.shape({
                value: PropTypes.bool
            }),
            metroBadgeNumberUsage: PropTypes.shape({
                value: PropTypes.bool
            })
        }),
        choseEligibility: PropTypes.bool
    }).isRequired,
    hasSsn: PropTypes.bool,
    hasDepartmentNumber: PropTypes.bool,
    hasEmployeeNumber: PropTypes.bool,
    hasMetroBadgeNumber: PropTypes.bool
};

MLPayrollDeductComponent.defaultProps = {
    hasSsn: false,
    hasDepartmentNumber: false,
    hasEmployeeNumber: false,
    hasMetroBadgeNumber: false
};

export default MLPayrollDeductComponent;
